import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_MODIFIER_CATEGORIES_BY_STORE_ID } from "src/constants/queries";
import { failureToast } from "src/utils/toasts";
import { RootState } from "src/store/index";
import { set_modifier_categories } from "src/store/features/modifier-categories-slice";
import type { MenuListActiveFilter } from "src/constants/menuListActiveFilter";

export const useModifierCategoriesByStoreCorrelationId = () => {

  const [isModifierCategoriesLoading, setIsModifierCategoriesLoading] = useState(false);
  const dispatch = useDispatch();
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  
  const { modifierCategories } = useSelector(
    (state: RootState) => state.modifierCategories
  );

  const fetchModifierCategoriesByStoreCorrelationId = useCallback(
    async (activeFilter: MenuListActiveFilter = "ACTIVE") => {
      if (!hasRestaurant?.correlationId) return;

      setIsModifierCategoriesLoading(true);

      try {
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: GET_MODIFIER_CATEGORIES_BY_STORE_ID,
          variables: {
            storeCorrelationId: hasRestaurant?.correlationId,
            activeFilter,
          },
        });

        if (data?.data?.modifierCategoriesByStoreCorrelationId) {
          dispatch(set_modifier_categories(data.data.modifierCategoriesByStoreCorrelationId));
        }
      } catch (err) {
        console.error("Error fetching modifier categories by store:", err);
        const errorMessage = "Failed to fetch modifier categories by store";
        failureToast(errorMessage);
      } finally {
        setIsModifierCategoriesLoading(false);
      }
    },
    [axBe, hasRestaurant?.correlationId, dispatch]
  );

  return {
    modifierCategories,
    isModifierCategoriesLoading,
    fetchModifierCategoriesByStoreCorrelationId,
  };
};
